import React, { useEffect } from "react";
import { getErrorDetails } from "../../app/appUtils";
import { Modal } from "../../components/ui/Modal";
import { useToast } from "../../hooks/useToast";
import AddRoleModal from "./AddRole";
import { useGetRoleByIdQuery } from "./userApiSlice";

interface EditRoleProps {
  roleId: string;
  onClose: () => void;
}

/**
 * Loads a role via GET /roles/{id} and opens the role modal in edit mode,
 * which submits to /roles/create/update-rolewithpermissions with the roleId.
 */
const EditRoleModal: React.FC<EditRoleProps> = ({ roleId, onClose }) => {
  const toast = useToast();

  const { data, isLoading, isError, error } = useGetRoleByIdQuery(roleId, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (isError) {
      toast.error({
        title: "Error",
        message: getErrorDetails(error).message || "Failed to load role",
      });
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError]);

  const role = data?.data;

  if (isLoading || !role) {
    return (
      <Modal
        isOpen
        onClose={onClose}
        title="Loading role..."
        className="max-w-md"
      >
        <div className="p-8 text-center text-gray-500">Please wait...</div>
      </Modal>
    );
  }

  return (
    <AddRoleModal
      isOpen
      mode="edit"
      onClose={onClose}
      existingRole={{
        roleId: role.id,
        name: role.name,
        description: role.description,
        permissions: role.permissions ?? [],
      }}
    />
  );
};

export default EditRoleModal;
